interface IDataUrlToFileProps {
  dataUrl: string;
  fileName: string;
  mimeType: string;
}

export const dataUrlToFile = ({
  dataUrl,
  fileName,
  mimeType,
}: IDataUrlToFileProps): File => {
  const base64 = dataUrl.split(",")[1];
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let index = 0; index < binaryString.length; index++) {
    bytes[index] = binaryString.codePointAt(index) ?? 0;
  }

  return new File([bytes], fileName, { type: mimeType });
};
